import { render } from "./ChooseSubNotificationModal.vue?vue&type=template&id=07344500"
import script from "./ChooseSubNotificationModal.vue?vue&type=script&lang=js"
export * from "./ChooseSubNotificationModal.vue?vue&type=script&lang=js"

import "./ChooseSubNotificationModal.vue?vue&type=style&index=0&id=07344500&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__